const jq = window.jQuery || window.$;
export default jq;
export { jq as jQuery };
